import type { ReactNode } from 'react';

export function PixelPanel({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`bg-ink-800 border-2 border-ink-700 p-4 ${className}`}>
      {children}
    </div>
  );
}
